import React from 'react'

export const ProfileScreen = () => {
  return (
    <div>
      profile
    </div>
  )
}
